// WhatsApp will not deliver a video over 16 MB by link. The backend does
// compress oversized clips on the way out, but that is lossy and slow on the
// first send — so warn the admin here rather than letting it happen quietly.
export const WHATSAPP_SAFE_VIDEO_SIZE_IN_MB = 16;

// Same ceilings the backend validates against
// (PRODUCT_USAGE_GUIDE_CONSTANTS.DOMAIN.ENTITY).
export const USAGE_GUIDE_QUESTION_MAX_LENGTH = 200;
export const USAGE_GUIDE_RICH_TEXT_MAX_LENGTH = 20000;
